import { STATUS_STYLES, DOT_STYLES } from "../lib/monitor";
import { cn } from "../lib/utils";

export function StatusBadge({ variant = "unknown", children, dot = true, pulse = false, className, testid }) {
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-mono font-medium border whitespace-nowrap",
        STATUS_STYLES[variant],
        className
      )}
    >
      {dot && (
        <span className="relative flex h-1.5 w-1.5">
          {pulse && <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping", DOT_STYLES[variant])} />}
          <span className={cn("relative inline-flex h-1.5 w-1.5 rounded-full", DOT_STYLES[variant])} />
        </span>
      )}
      {children}
    </span>
  );
}

export function StatusDot({ variant = "unknown", pulse = false, className, testid }) {
  return (
    <span className="relative inline-flex h-2.5 w-2.5" data-testid={testid}>
      {pulse && <span className={cn("absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping", DOT_STYLES[variant])} />}
      <span className={cn("relative inline-block h-2.5 w-2.5 rounded-full ring-2 ring-white shadow-sm", DOT_STYLES[variant], className)} />
    </span>
  );
}
